import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { translate } from '../i18n/i18n';
import { token as liveToken } from '../auth/session';

export type AssistAccess = { visible: boolean; released: boolean; developer: boolean; admin: boolean; expertStatus: string | null; commissionPct: number };

export function useAssistAccess(): AssistAccess | null {
  const { token } = useAuth();
  const [access, setAccess] = useState<AssistAccess | null>(null);
  useEffect(() => {
    if (!token) { setAccess(null); return; }
    api<AssistAccess>('/assist/access', { token }).then(setAccess).catch(() => setAccess(null));
  }, [token]);
  return access;
}

export const NEED_LABEL: Record<string, string> = {
  setup: 'Set up EasyLearning',
  course: 'Plan a course',
  programs: 'Make programs',
  schedule: 'Make a weekly schedule',
  milestones: 'Plan milestones',
};

export const money = (pence: number) => `£${(pence / 100).toFixed(2)}`;
export const describe = (minutes: number) => {
  const h = Math.floor(minutes / 60), m = minutes % 60;
  return [h ? (h === 1 ? translate('{h} hour', { h }) : translate('{h} hours', { h })) : '', m ? translate('{m} minutes', { m }) : ''].filter(Boolean).join(' ');
};
export const hours = (minutes: number) => translate('{h} h {m} min', { h: Math.floor(minutes / 60), m: minutes % 60 });

export async function openFile(path: string) {
  const win = window.open('', '_blank');
  try {
    const bearer = await liveToken();
    const res = await fetch(`/api${path}`, { headers: bearer ? { Authorization: `Bearer ${bearer}` } : {}, credentials: 'omit' });
    if (!res.ok) throw new Error();
    const url = URL.createObjectURL(await res.blob());
    if (win) win.location.href = url;
    else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    win?.close();
    throw new Error(translate('That file could not be opened.'));
  }
}
